export enum AvailableLanguages {
  ENG = 'en',
  SRSR = 'srsr',
}
